module.exports = __webpack_public_path__ + "img/partner-eos-amesterdam.1b01f1a.png";